import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["currentUrl", "toggle", "formToggle", "firstField", "contactButton"];
  static values = {
    toggleId: { type: String, default: "contact_widget_toggle" },
    formToggleId: { type: String, default: "contact_widget_form_toggle" },
  };

  captureContext() {
    this.currentUrlTarget.value = window.location.href;
  }

  open(event) {
    event.preventDefault();
    this.#check(this.formToggleIdValue);
    this.#check(this.toggleIdValue);
  }

  showForm() {
    this.formToggleTarget.checked = true;
    this.firstFieldTarget.focus();
  }

  showHelp() {
    this.formToggleTarget.checked = false;
    this.contactButtonTarget.focus();
  }

  close() {
    this.toggleTarget.checked = false;
    if (this.hasFormToggleTarget) this.formToggleTarget.checked = false;
    this.toggleTarget.focus();
  }

  #check(id) {
    const toggle = document.getElementById(id);
    if (toggle) {
      toggle.checked = true;
      toggle.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
}
